<template>
    <div class="main_div">
        <div style="height: auto" :key="componentKey">
            <n-space>
                <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
                    <n-space item-style="display: flex;" align="center">
                        <div style="font-size: 20px; width: 150px; font-weight: bold">Dashboard</div>
                    </n-space>
                    <div class="content_delimiter_line"></div>
                    <div><p>대쉬보드</p></div>
                </NCard>
            </n-space>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { NSpace, NCard } from "naive-ui";
const componentKey = ref(0);
</script>

<style scope></style>
